import themes from './theme.json'

export function addColor(init) {
	let keys = ['blue', 'green']
	const obj = themes[keys.indexOf(init) != -1 ? init : 'green']
	console.log(obj);
	// html 添加主题样式
	for (const key in obj) {
		document.documentElement.style.setProperty(key, obj[key]);
	}
}